module.exports = __webpack_public_path__ + "media/assets/images/Instagram-9929c87b75f25fb22116b5ac56ac1834.svg";